/* istanbul ignore file */
export default
`<div ref="printRef">
    <div :class="containerClasses" :style="containerStyles">
        <div class="header-content" :class="headerClasses" :style="headerStyles" ref="headerContent" v-if="settings.enableHeader">
            <div class="header-top-row">
                <div class="header-logo" v-if="settings.headerLogoImage">
                    <img :src="settings.headerLogoImage" :style="headerLogoStyles" :alt="settings.headerLogoAltText" :title="settings.headerLogoTitle"/>
                </div>
                <div class="header-text">
                    <component :is="{template: '<div>' + settings.header + '</div>', props:{user: {default: false}}}" :user="user" />
                </div>
                <div class="header-components" v-if="positionsFiltered[0]" v-for="(component, index) in positionsFiltered[0].components" :key="component.cId" >
                    <component 
                        v-bind="componentMappedProps[component.cId.split('__')[0]]" 
                        :is="component.cType" 
                        :cId="component.cId" 
                        :editor-enabled="editorEnabled"
                        v-if="displayedComponents[component.cId]" 
                        v-show="showedComponents[component.cId]"
                        :unique-store-id="uniqueStoreId"
                        class="layout-component"
                        :ref="'ref__' + component.cId"
                    ></component>
                </div>
            </div>
            <p v-if="settings.headerMessage">{{settings.headerMessage}}</p>
        </div>
        <div :id="'column_' + templateUniqueId">
            <div v-if="positionsFiltered[1]" v-for="(component, index) in positionsFiltered[1].components" :key="component.cId" >
                <component
                    v-bind="componentMappedProps[component.cId.split('__')[0]]"
                    :is="component.cType" 
                    :cId="component.cId"
                    v-if="displayedComponents[component.cId]" 
                    v-show="showedComponents[component.cId]"
                    :editor-enabled="editorEnabled" 
                    :unique-store-id="uniqueStoreId"
                    :style="columnSpecificComponentStyles[0]"
                    class="layout-component"
                    :ref="'ref__' + component.cId"
                ></component>
            </div>
        </div>
        <div class="footer-content" ref="footerContent" v-if="settings.enableFooter">
            <div v-if="positionsFiltered[2]" v-for="(component, index) in positionsFiltered[2].components" :key="component.cId" >
                <component 
                    v-bind="componentMappedProps[component.cId]" 
                    :is="component.cType" 
                    :cId="component.cId" 
                    :editor-enabled="editorEnabled"
                    v-if="displayedComponents[component.cId]" 
                    v-show="showedComponents[component.cId]"
                    :unique-store-id="uniqueStoreId"
                    :style="columnSpecificComponentStyles[0]"
                    class="layout-component"
                    :ref="'ref__' + component.cId"
                ></component>
            </div>
        </div>
    </div>
</div>`;
